define([
    "../../hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.service("carrierZoneDrawingService", [
        "hereMapsService",
        "carrierDrawingCommonService",
        function (hereMapsService, carrierDrawingCommonService) {
            var Here = null;
            var map = null;
            var icon = null;
            var behavior = null;

            var points = [];    // H.geo.Point[] — vértices capturados
            var tempObjects = [];    // Polígonos temporários no mapa
            var previewLine = null;  // linha fantasma, entre os pontos
            var onCompleteCallback = null;
            var pointerDown = null; // guarda posição quando clicar

            // Eventos
            var pointerDownEvent = null;
            var pointerUpEvent = null;
            var pointerMoveEvent = null;
            var firstPointerEnterEvent = null;
            var firstPointerLeaveEvent = null;

            var PX_TO_CLOSE_POLYGON = 20;

            return {
                startDrawing: startDrawing,
                cancelDrawing: cancelDrawing
            };

            function cancelDrawing() {
                cleanup();
                onCompleteCallback = null;
            }

            function startDrawing(callback) {
                onCompleteCallback = callback;

                Here = hereMapsService.getHere();
                map = hereMapsService.getMap();
                icon = new Here.map.Icon("images/circle-solid-white.svg", {
                    anchor: {x: 5, y: 3}
                });

                hereMapsService.getBehavior().disable(
                    Here.mapevents.Behavior.Feature.PANNING
                );

                carrierDrawingCommonService.setCursor(true);

                // eventos de mudar o cursor no primeiro marker

                firstPointerEnterEvent = function () {
                    carrierDrawingCommonService.setCursor(false);
                    map.getViewPort().element.style.cursor = "pointer";
                };

                firstPointerLeaveEvent = function () {
                    carrierDrawingCommonService.setCursor(true);
                    map.getViewPort().element.style.cursor = "auto";
                };

                // pointerDown clicou mas ainda não soltou
                // salva o ponto
                pointerDownEvent = function (event) {
                    if (event.currentPointer.button !== 0) {
                        return;
                    }
                    pointerDown = {
                        x: event.currentPointer.viewportX,
                        y: event.currentPointer.viewportY
                    };
                };

                // moveu o mouse, cria linha invisivel
                pointerMoveEvent = function (event) {
                    if (points.length === 0) {
                        return;
                    }
                    var coordinate = map.screenToGeo(
                        event.currentPointer.viewportX,
                        event.currentPointer.viewportY
                    );
                    updatePreviewLine(coordinate);
                };

                // pointerUp soltou o click tipo um click=tap
                pointerUpEvent = function (event) {
                    if (!pointerDown) {
                        return;
                    }

                    if (event.currentPointer.button !== 0) {
                        pointerDown = null;
                        return;
                    }

                    var pointA = {
                        x: event.currentPointer.viewportX,
                        y: event.currentPointer.viewportY
                    };

                    var distance = carrierDrawingCommonService.getPixelDistance(pointA, pointerDown);
                    pointerDown = null;

                    if (!carrierDrawingCommonService.isValidTap(distance)) {
                        return;
                    }

                    var point = map.screenToGeo(
                        event.currentPointer.viewportX,
                        event.currentPointer.viewportY
                    );
                    onTap(point);
                };

                map.addEventListener("pointerdown", pointerDownEvent);
                map.addEventListener("pointermove", pointerMoveEvent);
                map.addEventListener("pointerup", pointerUpEvent);
            }

            function onTap(point) {
                if (points.length >= 3) {
                    var distPx = pixelDistance(points[0], point);
                    if (isNearInPxToCloseThePolygon(distPx)) {
                        closePolygon();
                        return;
                    }
                }

                points.push(point);
                addVertexMarker(point);

                if (points.length >= 2) {
                    drawSegment(points[points.length - 2], points[points.length - 1]);
                }
            }

            function isNearInPxToCloseThePolygon(distanceInPx) {
                return distanceInPx < PX_TO_CLOSE_POLYGON;
            }

            function drawSegment(from, to) {
                var lineString = new Here.geo.LineString();
                lineString.pushPoint(from);
                lineString.pushPoint(to);

                var polyline = new Here.map.Polyline(lineString, {
                    style: {
                        strokeColor: "#72907f",
                        lineWidth: 3
                    }
                });

                map.addObject(polyline);
                tempObjects.push(polyline);
            }

            function addVertexMarker(point) {
                var vertexMarker = new Here.map.Marker(point, {
                        icon: icon
                    }
                );
                vertexMarker.setData(
                    {
                        isFirst: isFirstMarker()
                    }
                );

                map.addObject(vertexMarker);
                tempObjects.push(vertexMarker);

                if (isFirstMarker()) {
                    vertexMarker.addEventListener("pointerenter", firstPointerEnterEvent);
                    vertexMarker.addEventListener("pointerleave", firstPointerLeaveEvent);
                }
            }

            function isFirstMarker() {
                return points.length === 1;
            }

            function pixelDistance(p1, p2) {
                var a = map.geoToScreen(p1);
                var b = map.geoToScreen(p2);
                return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
            }

            function updatePreviewLine(cursorCoordinate) {
                var lineString = new Here.geo.LineString();
                lineString.pushPoint(points[points.length - 1]);
                lineString.pushPoint(cursorCoordinate);

                if (previewLine) {
                    previewLine.setGeometry(lineString);
                    return;
                }

                previewLine = new Here.map.Polyline(lineString, {
                    style: {
                        strokeColor: "rgba(54, 54, 54, 0.5)",
                        lineWidth: 1,
                    },
                    volatility: true
                });

                map.addObject(previewLine);
            }

            function closePolygon() {
                if (points.length < 3) {
                    cleanup();
                    return;
                }

                var polygon = carrierDrawingCommonService.createClosedPolygon(points);

                onCompleteCallback([polygon]);

                cleanup();
                startDrawing(onCompleteCallback);
            }

            function cleanup() {
                if (!pointerDownEvent || !pointerUpEvent || !pointerMoveEvent) {
                    return;
                }

                tempObjects.forEach(function (tempObjects) {
                    var data = tempObjects.getData();
                    if (data && data.isFirst) {
                        tempObjects.removeEventListener("pointerenter", firstPointerEnterEvent);
                        tempObjects.removeEventListener("pointerleave", firstPointerLeaveEvent);
                    }
                    map.removeObject(tempObjects);
                });

                if (previewLine) {
                    map.removeObject(previewLine);
                    previewLine = null;

                }

                if (map) {
                    map.removeEventListener("pointerdown", pointerDownEvent);
                    map.removeEventListener("pointerup", pointerUpEvent);
                    map.removeEventListener("pointermove", pointerMoveEvent);
                }

                if (behavior) {
                    carrierDrawingCommonService.setCursor(false);
                    behavior.enable(
                        Here.mapevents.Behavior.Feature.PANNING
                    );
                }

                points = [];
                tempObjects = [];
                pointerDown = null;
                Here = null;
                map = null;
                behavior = null;
            }
        }
    ]);
});